import type { ReactElement } from 'react';

const SAML_ATTRIBUTES = [
  { attr: 'email', desc: "User's email — used as Kirin login ID" },
  { attr: 'userName', desc: 'Username / login identifier' },
  { attr: 'name', desc: "User's display name" },
] as const;

export function RequiredIdpSettings(): ReactElement {
  return (
    <div className="rounded-md border bg-muted/40 overflow-hidden">
      <div className="px-3 py-2 border-b bg-muted/60">
        <p className="text-xs font-semibold tracking-wide uppercase text-muted-foreground">
          Required IdP settings
        </p>
      </div>
      <div className="px-3 py-2.5 space-y-3">
        <div className="flex items-center gap-2 text-xs">
          <span className="w-28 shrink-0 text-muted-foreground">
            Name ID format
          </span>
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-xs">
            EmailAddress
          </code>
        </div>
        <div className="border-t pt-2.5 space-y-1.5">
          <p className="text-xs text-muted-foreground">
            Your IdP must include these attributes in the SAML assertion:
          </p>
          {SAML_ATTRIBUTES.map(({ attr, desc }) => (
            <div key={attr} className="flex items-center gap-2">
              <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-xs shrink-0">
                {attr}
              </code>
              <span className="text-xs text-muted-foreground">{desc}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

RequiredIdpSettings.displayName = 'RequiredIdpSettings';
